// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://cmlxmxlhuocukdpxndjo.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNtbHhteGxodW9jdWtkcHhuZGpvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgzNjQ0ODgsImV4cCI6MjA4Mzk0MDQ4OH0.laYkuZv2v5pDQ1_QvsCkg_qXLwWYlsGEwWgeAT8p8bQ";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
